export const WEIGHT_UNIT = {
  OZ: 'oz',
  LB: 'lb',
  GM: 'gm',
  KG: 'kg',
}

export const OPTION_WEIGHT_UNIT = [
  {label: 'oz', value: WEIGHT_UNIT.OZ},
  {label: 'lb', value: WEIGHT_UNIT.LB},
  {label: 'gm', value: WEIGHT_UNIT.GM},
  {label: 'kg', value: WEIGHT_UNIT.KG},
]

export const OPTION_PACKAGE_TYPE = {
  INPUT_DIMENSION: {label: 'INPUT_DIMENSION', value: 'input_dimension'},
  CUSTOM_PACKAGE: {label: 'CUSTOM_PACKAGE', value: 'custom_package'},
  CARRIER_STANDARD_PACKAGE: {label: 'CARRIER_STANDARD_PACKAGE', value: 'carrier_standard_package'},
}
export const CARRIER_PACKAGE_TYPE = [
  {
    label: 'USPS Priority Mail Flat Rate Package',
    value: 'usps_priority_mail_flat_rate_package',
  },
  {
    label: 'Cubic',
    value: 'usps_cubic_soft_pack',
  },
]

export const DIMENSION_UNIT = {
  IN: 'in',
  CM: 'cm',
  MM: 'mm',
} as const

export type DimensionUnit = typeof DIMENSION_UNIT[keyof typeof DIMENSION_UNIT]

export const OPTION_DIMENSION_UNIT = [
  {label: 'in', value: DIMENSION_UNIT.IN},
  {label: 'cm', value: DIMENSION_UNIT.CM},
  {label: 'mm', value: DIMENSION_UNIT.MM},
]

export type WeightUnit = typeof WEIGHT_UNIT[keyof typeof WEIGHT_UNIT]

export const DIMENSIONS = ['length', 'width', 'height']
export const DIMENSIONS_PLACEHOLDER = {length: 'L', width: 'W', height: 'H'}

export const UNIT_VALUES = {
  WEIGHT_CARRIER: {
    oz: {max: 1120},
    lb: {max: 70},
    gm: {max: 31751},
    kg: {max: 31.5},
  },
  WEIGHT: {
    oz: {max: 10000},
    lb: {max: 625},
    gm: {max: 283495},
    kg: {max: 283.5},
  },
  DIMENSION: {
    in: {max: 100},
    cm: {max: 254},
    mm: {max: 2540},
  },
  PACKAGE_COUNT: {
    max: 200,
    limit_each_row: 100,
    limit_row: 50,
  },
}

export const OrderStatus = {
  OPEN: 'open',
  SHIPPED: 'shipped',
  AWAITING_PAYMENT: 'awaiting_payment',
  ON_HOLD: 'on_hold',
  CANCELLED: 'cancelled',
  ERROR: 'error',
} as const
